import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SelectQueue from '../views/SelectQueue.vue'
import SelectService from '../views/SelectService.vue'
import SelectChannel from '../views/SelectChannel.vue'
import RGPD from '../views/RGPD.vue'
import PersonalData from '../views/PersonalData.vue'
import SelectSlot from '../views/SelectSlot.vue'
import Confirmation from '../views/Confirmation.vue'
import InOfficeFlow from '../views/InOfficeFlow.vue'
import MyTickets from '../views/MyTickets.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/home/:uuid',
    name: 'Home2',
    component: Home
  },
  {
    path: '/selectqueue',
    name: 'SelectQueue',
    component: SelectQueue
  },
  {
    path: '/selectservice',
    name: 'SelectService',
    // component: () => import(/* webpackChunkName: "about" */ '../views/SelectService.vue')
    component: SelectService
  },
  {
    path: '/queue/:queueID/:lang',
    name: 'SelectService2',
    // component: () => import(/* webpackChunkName: "about" */ '../views/SelectService.vue')
    component: SelectService
  },
  {
    path: '/queue/:queueID',
    name: 'SelectService3',
    // component: () => import(/* webpackChunkName: "about" */ '../views/SelectService.vue')
    component: SelectService
  },
  {
    path: '/selectchannel',
    name: 'SelectChannel',
    component: SelectChannel
  },
  {
    path: '/rgpd',
    name: 'RGPD',
    component: RGPD
  },
  {
    path: '/personaldata',
    name: 'PersonalData',
    component: PersonalData
  },
  {
    path: '/selectslot',
    name: 'SelectSlot',
    component: SelectSlot
  },
  {
    path: '/confirmation',
    name: 'Confirmation',
    component: Confirmation
  },
  {
    path: '/inoffice',
    name: 'InOfficeFlow',
    component: InOfficeFlow
  },
  {
    path: '/mytickets',
    name: 'MyTickets',
    component: MyTickets
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
